import React, { useState } from "react"
import { FeedSpinner } from "../../components/shared/Spinner"
import { RequestError } from "../../components/shared/RequestError"
import UserAvatar from "../../components/shared/Header/UserAvatar"
import { useFollowersPaged } from "../../hooks/useFollowersPaged"
import { downloadFollowersCsv } from "../../requests/userBands"
import Pagination from "../../components/shared/Pagination"

interface FollowersProps {
  bandId: number
}

export const Followers: React.FC<FollowersProps> = ({ bandId }) => {
  const [page, setPage] = useState(1)
  const [isExporting, setIsExporting] = useState(false)
  const { status, data, error, isPreviousData } = useFollowersPaged(bandId, page, 40)

  const handleExportCSV = async () => {
    setIsExporting(true)
    try {
      await downloadFollowersCsv(bandId)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <div>
      <h2 className="lg:hidden font-bold text-xl uppercase border-b-4 border-black mb-4">
        Followers
      </h2>
      {data?.total_count > 0 && (
        <div className="flex justify-end mb-3">
          <button
            onClick={handleExportCSV}
            disabled={isExporting}
            className="text-sm text-blue-700 hover:underline disabled:opacity-50"
          >
            {isExporting ? "Exporting..." : "Export CSV"}
          </button>
        </div>
      )}
      {status === "loading" ? (
        <FeedSpinner />
      ) : status === "error" ? (
        <RequestError error={error} />
      ) : data ? (
        data.total_count === 0 ? (
          <div>
            No followers yet...{" "}
            <a
              href="https://www.youtube.com/watch?v=9gpbjprHivM"
              target="_blank"
              rel="noreferrer"
            >
              Spread Your Love!
            </a>
          </div>
        ) : (
          <>
            <div className={`flex flex-wrap gap-2 ${isPreviousData ? "opacity-50" : ""}`}>
              {data.users.map((user: any) => {
                const name = user.band?.name || user.nickname || user.name
                const href = user.band?.band_path
                const avatar = (
                  <UserAvatar
                    handleClick={() => {}}
                    user={user}
                    size="small"
                    inHeader={false}
                  />
                )
                return href ? (
                  <a key={user.id} href={href} title={name}>
                    {avatar}
                  </a>
                ) : (
                  <span key={user.id} title={name}>
                    {avatar}
                  </span>
                )
              })}
            </div>
            <Pagination
              page={data.page}
              totalPages={data.total_pages}
              totalCount={data.total_count}
              hasNextPage={data.has_next_page}
              onPrev={() => setPage((p) => Math.max(1, p - 1))}
              onNext={() => setPage((p) => p + 1)}
            />
          </>
        )
      ) : null}
    </div>
  )
}
